import UploadProfilePicture from './UploadProfilePicture';
import DiscoverPeople from './DiscoverPeople';
import DiscoverStock from './DiscoverStock';
import ConnectFacebook from './ConnectFacebook';

function OnBoarding({ progress }) {
  return (
    <>
      {progress == 0 && <UploadProfilePicture />}
      {progress == 1 && <ConnectFacebook />}
      {progress == 2 && <DiscoverPeople />}
      {progress == 3 && <DiscoverStock />}
    </>
  );
}

export default OnBoarding;
